import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/router';
import * as S from './InvoicesTabs.styles';
import { Chip } from '@/components/UI/Chip/Chip';
import { STATUS_TABS } from '@/features/Profile/sections/Invoices/Invoices.constants';
import { InvoiceStatusFilter } from '@/features/Profile/sections/Invoices/Invoices.types';
import { QUERY } from '@/constants/common';

interface InvoicesTabsProps {
  activeStatus: InvoiceStatusFilter;
}

export const InvoicesTabs = ({ activeStatus }: InvoicesTabsProps) => {
  const { t } = useTranslation();
  const router = useRouter();

  function handleTabClick(status: InvoiceStatusFilter) {
    const query = { ...router.query };

    if (status === InvoiceStatusFilter.All) {
      delete query[QUERY.status];
    } else {
      query[QUERY.status] = status;
    }

    router.replace({ query }, undefined, { shallow: true, scroll: false });
  }

  return (
    <S.Container>
      {STATUS_TABS.map(({ value, labelKey }) => (
        <Chip
          key={value}
          appearance={activeStatus === value ? 'primary' : 'gray'}
          isRounded
          onClick={() => handleTabClick(value)}
        >
          {t(labelKey)}
        </Chip>
      ))}
    </S.Container>
  );
};
